<div>

  <!-- ================= TITLE ================= -->
  @if (!showAddUser) {
    <div>
      <div class="text-xl font-semibold mb-2">
        User Management
      </div>
      <div class="text-base line-height-3 text-700">
        Configure user management settings below.
      </div>
    </div>
  }

  @if (!showAddUser) {
    <hr class="my-4" />
  }

  <!-- ================= COMPANY DROPDOWN ================= -->
  @if (!showAddUser && !selectedCompany) {
    <div
      class="flex flex-column w-20rem gap-2"
      >
      <label
        for="company"
        class="text-sm font-semibold text-700"
        >
        Select Company
      </label>
      <p-select
        id="company"
        [(ngModel)]="selectedCompany"
        [options]="companies"
        optionLabel="label"
        optionValue="value"
        placeholder="Select"
        appendTo="body"
        styleClass="w-full user-mg-dropdown"
        >
      </p-select>
    </div>
  }

  <!-- ================= MAIN CONTENT ================= -->
  @if (selectedCompany && !showAddUser) {
    <div>
      <!-- ================= ACCOUNT HEADER ================= -->
      <div class="text-lg font-medium mb-2">
        Account Information
      </div>
      <!-- ================= ACTION ROW ================= -->
      <div class="flex justify-content-between align-items-center mb-3">
        <!-- LEFT -->
        <button
          pButton
          icon="pi pi-plus"
          label="Add New"
          class="p-button-sm border-round p-button-secondary"
          (click)="openAddUser()">
        </button>
        <!-- RIGHT -->
        <div class="flex gap-2">
          <button
            pButton
            label="Import Users"
            class="p-button-sm p-button-outlined border-round">
          </button>
          <button
            pButton
            label="Export Users"
            class="p-button-sm p-button-outlined border-round">
          </button>
        </div>
      </div>
      <!-- ================= CHECKBOX ================= -->
      <div class="flex align-items-center gap-2 mb-4">
        <p-checkbox
          inputId="activeUsers"
          [(ngModel)]="includeInactive"
          binary="true"
          class="sara-checkbox">
        </p-checkbox>
        <label
          for="activeUsers"
          class="cursor-pointer text-base text-700">
          Include active users
        </label>
      </div>
      <!-- ================= TABLE WRAPPER ================= -->
      <div class="border-1 border-300 border-round overflow-hidden">
        <!-- ================= TABLE HEADER ================= -->
        <div
        class="flex justify-content-between align-items-center
               px-3 py-2
               border-bottom-1 border-300
               surface-200"
          >
          <!-- LEFT -->
          <div
            class="flex align-items-center cursor-pointer text-700 font-semibold gap-2"
            (click)="toggleSort()"
            >
            <span class="text-sm">User Info</span>
            <i class="pi pi-arrow-right-arrow-left rotate-90 text-primary"></i>
          </div>
          <!-- RIGHT -->
          <span class="p-input-icon-left">
            <i class="pi pi-search text-500"></i>
            <input
              pInputText
              type="text"
              placeholder="Search"
              class="p-inputtext-sm w-12rem pl-5 border-1 border-400 border-round-md custom-search-user-mgmt"
              [(ngModel)]="searchTerm"
              />
          </span>
        </div>
        <!-- ================= TABLE ================= -->
        <p-table
          [value]="pagedUsers()"
          [paginator]="false"
          styleClass="p-datatable-sm"
          >
          <ng-template pTemplate="body" let-user>
            <tr>
              <td>
                <div class="flex flex-column gap-1">
                  <span class="text-sm font-medium">
                    {{ user.firstName }} {{ user.lastName }}
                  </span>
                  <span class="text-xs text-500">
                    {{ user.email }}
                  </span>
                </div>
              </td>
              <td class="text-right">
                <span class="cursor-pointer text-sm font-semibold text-primary">
                  Select
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- ================= CUSTOM PAGINATION ================= -->
        <div
        class="flex align-items-center justify-content-between
               px-4 py-3
               border-top-1 border-300
               surface-100"
          >
          <!-- LEFT -->
          <div class="flex align-items-center gap-2">
            <!-- Previous -->
            <button
            class="flex align-items-center justify-content-center
                   w-2rem h-2rem border-circle border-none
                   bg-sara-blue text-white cursor-pointer"
              [disabled]="currentPage === 0"
              (click)="changePage(currentPage - 1)">
              <i class="pi pi-chevron-left text-sm"></i>
            </button>
            <!-- Page Numbers -->
            @for (page of [].constructor(totalPages); track $index; let i = $index) {
              <button
              class="flex align-items-center justify-content-center
                     w-2rem h-2rem border-circle border-none
                     text-white text-sm font-medium cursor-pointer"
              [ngClass]="
                i === currentPage
                  ? 'bg-sara-dark-blue'
                  : 'bg-sara-dark-gray'
              "
                (click)="changePage(i)">
                {{ i + 1 }}
              </button>
            }
            <!-- Next -->
            <button
            class="flex align-items-center justify-content-center
                   w-2rem h-2rem border-circle border-none
                   bg-sara-blue text-white cursor-pointer"
              [disabled]="currentPage === totalPages - 1"
              (click)="changePage(currentPage + 1)">
              <i class="pi pi-chevron-right text-sm"></i>
            </button>
          </div>
          <!-- RIGHT -->
          <div class="flex align-items-center gap-2">
            <span class="text-sm font-medium">Show:</span>
            <p-select
              [options]="rowsOptions"
              [(ngModel)]="rows"
              optionLabel="label"
              optionValue="value"
              styleClass="p-dropdown-sm user-mg-dropdown"
              (onChange)="changeRows($event.value)"
              placeholder="Rows">
            </p-select>
          </div>
        </div>
      </div>
    </div>
  }

</div>

<!-- ================= ADD USER COMPONENT ================= -->
@if (showAddUser) {
  <div>
    <app-add-user (cancelAction)="closeAddUser()"></app-add-user>
  </div>
}
